import React from "react";
import { useAppContext, usePersistedState } from "../AppContext";
import { useTranslation } from "react-i18next";


export const CustomInvoiceContext = React.createContext(null);

export const useCustomInvoiceStore = () => React.useContext(CustomInvoiceContext);

let store;

export const getStore = () => ({ ...store });

export const CustomInvoiceContextProvider = ({ children }) => {
      const {
          user: [user],
          selectedCompany: [selectedCompany],
          dates: [dates],
      } = useAppContext();

      const { t } = useTranslation("translations");
      const [persistedData, setPersistedData] = usePersistedState(
          null,
          "sessionData"
      );
      
      const company = user?.companiesRights?.find(
        (company) => company.id === parseInt(selectedCompany)
      )
  
      const businessUnitCodes = React.useMemo(() => {
          return [{
              label: t("invoice.businessUnitCode"),
              value: null,
          }].concat((company?.branches?.map((branch) => {
              return {
                  label: branch.businUnitCode + " | " + branch.sellerName,
                  value: branch.businUnitCode,
              };
          })??[]))
      }, [company])
  
      const businessUnitSelected = businessUnitCodes.some(
          (branch) => branch?.value === persistedData?.businessUnitCode
      )
          ? persistedData?.businessUnitCode
          : null;
      


      const filterParams = {
        businessUnitCode: businessUnitSelected,
        currency: [],
        type: [],
        internalId: null,
        isEinvoice: null,
        isDeleted: "false",
        opCode: null,
        tin: null,
        recordUser: null,
        paymentMethodType: null,
        correctiveInvType: null,
        statusObj: [],
        isForeign: null,
        source: "MI",
        tcrCode: null,
    };

    const defaultFilters = {
      fromDate: dates.fromDate,
      toDate: dates.toDate,
      params: {
          ...filterParams,
      },
    };

    const [filters, setFilters] = React.useState(defaultFilters);

    const store={
      filters,
      setFilters,
      defaultFilters,
      filterParams,
      persistedData,
      setPersistedData,
      businessUnitCodes,
      businessUnitSelected,
    }

  return <CustomInvoiceContext.Provider value={store}>{children}</CustomInvoiceContext.Provider>;
};
